<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="SOURCE PROCESS" name="process">
      <div v-if="!$_.isEmpty(sourceProcess.sourceProcessName)">
        <span class="subtitle2">Name</span>
        <span class="value">{{sourceProcess.sourceProcessName}}</span>
      </div>
      <div
        :class="{'display-none':$_.isEmpty(sourceProcess.sourcePid) && !$_.isNumber(sourceProcess.sourcePid)}"
      >
        <span class="subtitle2">Pid</span>
        <span class="value">{{sourceProcess.sourcePid}}</span>
      </div>
      <div
        v-if="$_.isEmpty(sourceProcess.runSpaceId) && $_.isEmpty(handoffProcess.runSpaceId) && !$_.isEmpty(handoffProcess.remoteHost)"
      >
        <span class="subtitle2">IP</span>
        <span class="value">{{handoffProcess.remoteHost}}</span>
      </div>
      <div
        v-if="$_.isEmpty(sourceProcess.runSpaceId) && $_.isEmpty(handoffProcess.runSpaceId)"
        :class="{'display-none':$_.isEmpty(handoffProcess.remotePort) && !$_.isNumber(handoffProcess.remotePort)}"
      >
        <span class="subtitle2">Port</span>
        <span class="value">{{handoffProcess.remotePort}}</span>
      </div>
      <div v-if="!$_.isEmpty(sourceProcess.runSpaceId) || !$_.isEmpty(handoffProcess.runSpaceId)">
        <span class="subtitle2">Runspace ID</span>
        <span class="value">{{runSpaceId}}</span>
      </div>
    </el-collapse-item>
    <el-collapse-item title="HAND-OFF PROCESS" name="handoff">
      <div v-if="!$_.isEmpty(handoffProcess.sourceProcessName)">
        <span class="subtitle2">Name</span>
        <span class="value">{{handoffProcess.sourceProcessName}}</span>
      </div>
      <div
        :class="{'display-none':$_.isEmpty(handoffProcess.sourcePid) && !$_.isNumber(handoffProcess.sourcePid)}"
      >
        <span class="subtitle2">Pid</span>
        <span class="value">{{handoffProcess.sourcePid}}</span>
      </div>
      <div
        v-if="$_.isEmpty(sourceProcess.runSpaceId) && $_.isEmpty(handoffProcess.runSpaceId) && !$_.isEmpty(sourceProcess.remoteHost)"
      >
        <span class="subtitle2">IP</span>
        <span class="value">{{sourceProcess.remoteHost}}</span>
      </div>
      <div
        v-if="$_.isEmpty(sourceProcess.runSpaceId) && $_.isEmpty(handoffProcess.runSpaceId)"
        :class="{'display-none':$_.isEmpty(sourceProcess.remotePort) && !$_.isNumber(sourceProcess.remotePort)}"
      >
        <span class="subtitle2">Port</span>
        <span class="value">{{sourceProcess.remotePort}}</span>
      </div>
      <div v-if="!$_.isEmpty(sourceProcess.runSpaceId) || !$_.isEmpty(handoffProcess.runSpaceId)">
        <span class="subtitle2">Runspace ID</span>
        <span class="value">{{runSpaceId}}</span>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: "LateralMovementEventDetails",
  props: {
    iocDetails: {
      default: () => {
        return {};
      },
      type: [Object]
    }
  },
  data() {
    return {
      activeNames: ["process", "handoff"]
    };
  },
  computed: {
    sourceProcess: function() {
      if (_.isEmpty(this.iocDetails.iocEventsList)) {
        return {};
      }
      return this.iocDetails.iocEventsList[0];
    },
    handoffProcess: function() {
      if (_.isEmpty(this.iocDetails.iocEventsList)) {
        return {};
      }
      return this.iocDetails.iocEventsList[1];
    },
    runSpaceId: function() {
      return this.sourceProcess.runSpaceId || this.handoffProcess.runSpaceId;
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.el-collapse {
  overflow: scroll;
  border-bottom: none;
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.el-collapse-item >>> .el-collapse-item__content,
.ml-metadata_block {
  > div {
    display: flex;
    flex-wrap: nowrap;
    padding: 10px;

    > .subtitle2,
    .value {
      flex-grow: 1;
      align-self: auto;
      width: 50%;
    }
  }
}

.ml-metadata_block {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/ioc-details/LateralMovementEventDetails.vue